import classNames from 'classnames'
import { forwardRef, HTMLAttributes, ReactNode } from 'react'

import styles from './styles/header.module.scss'

export type FullscreenModalHeaderElement = HTMLDivElement

export interface FullscreenModalHeaderProps extends HTMLAttributes<FullscreenModalHeaderElement> {
  children: ReactNode
}

const FullscreenModalHeader = forwardRef<HTMLDivElement, FullscreenModalHeaderProps>(
  function FullscreenModalHeader(props, forwardRef) {
    const { className, children, ...rest } = props

    const classes = classNames(styles.root, className)

    return (
      <div {...rest} className={classes} ref={forwardRef}>
        {children}
      </div>
    )
  }
)

export default FullscreenModalHeader
